import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import PageHint from '../../../components/Common/PageHint';
import DeleteModal from '../../../components/Common/DeleteModal';
import LangModal from '../../../components/Common/LangModal';

import {
  addProducts as onAddProducts,
  updateProducts as onUpdateProducts,
  getProducts as onGetProducts,
  deleteProjects as onDeleteProjects,
} from "store/contacts/actions";

import axios from 'axios';

import {
  Name,
  Status
}
  from "./EcommerceOrderCol";

//redux
import { useSelector, useDispatch } from "react-redux";
import EcommerceOrdersModal from "./EcommerceOrdersModal";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Progress,
} from "reactstrap";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader';
import MultiSelectOption from "../MultiSelectOption";
import "jspdf-autotable";
import * as XLSX from 'xlsx';
import { makeUploadParams } from "../../../helpers/imageResize";

function EcommerceOrder() {

  document.title = "Ürünler | BUHARA - Admin Paneli";

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getEditProject, setEditProject] = useState(null);

  const [getSelectBlog, setSelectBlog] = useState([]);
  const [getIsAddBlog, setIsAddBlog] = useState(false);
  const [getBlogList, setBlogList] = useState([]);
  const [getOrderBlog, setOrderBlog] = useState(null);

  const [getIsAddLink, setIsAddLink] = useState(false);
  const [getSelectLink, setSelectLink] = useState([]);
  const [getLinkList, setLinkList] = useState([]);
  const [getProductsLinkList, setProductsLinkList] = useState([]);

  const [getWsText, setWsText] = useState(null);
  const [getSelectReply, setSelectReply] = useState([]);

  const [getIsAddQuesiton, setIsAddQuestion] = useState(false);
  const [getQuestion, setQuestion] = useState([]);
  const [loading, setLoading] = useState(false);

  const [getFileTr, setFileNameTR] = useState(null);
  const [getFileEng, setFileNameEng] = useState(null);

  // Alt Kategori State'i
  const [subOptions, setSubOptions] = useState([]);

  const dispatch = useDispatch();
  const { orders } = useSelector(state => ({
    orders: state.contacts.products,
  }));

  // --- Alt Kategorileri Çekme ---
  const _getSubCategoryList = async () => {
    try {
      const res = await axios.get(`https://buharaapi.stechomeyazilim.info/Products_SubCategory`);
      setSubOptions(res.data.value || res.data);
    } catch (error) {
      console.log("Alt kategori hatası:", error);
    }
  }

  useEffect(() => {
    _getSubCategoryList();
    if (orders && !orders.length) {
      dispatch(onGetProducts());
      setIsEdit(false);
    }
  }, [dispatch, orders]);

  useEffect(() => {
    setOrderList(orders);
  }, [orders]);

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders);
      setIsEdit(false);
    }
  }, [orders]);


  // Görseller sunucuya gitmeden önce tarayıcıda küçültülür (helpers/imageResize).
  const getUploadParams = makeUploadParams('https://buharaadmin.stechomeyazilim.info:8099/uploadfile');

  const handleChangeStatusTR = ({ xhr }) => {
    if (xhr && xhr.readyState === 4) {
      const result = JSON.parse(xhr.response);
      setFileNameTR(result.file.filename)
    }
  }
  const handleChangeStatusEng = ({ xhr }) => {
    if (xhr && xhr.readyState === 4) {
      const result = JSON.parse(xhr.response);
      setFileNameEng(result.file.filename)
    }
  }

  const _getBlogList = async () => {
    setBlogList([])
    await axios.get(`https://buharaapi.stechomeyazilim.info/Blog`)
      .then((res) => {
        res.data.map((item) => (
          setBlogList(oldArray => [...oldArray, { label: item.Blog_Title, value: item.ID }])
        ))
      })
  }

  const postBlogInProducts = async () => {
    try {
      if (getSelectBlog.length > 0) {
        getSelectBlog.map(async (item) => {
          let data = {
            Products_ID: getOrderBlog.ID,
            Blog_ID: item.value
          }
          await axios.post(`https://buharaapi.stechomeyazilim.info/Products_Blog`, data).then(async (res) => {
            dispatch(onGetProducts());
            toggleAddBlog()
          })
        })
      }
    } catch (err) { console.log(err) }
  }

  // Toggle Fonksiyonları
  const toggleAddQuestion = () => setIsAddQuestion(!getIsAddQuesiton);
  const toggleAddLink = () => setIsAddLink(!getIsAddLink);
  const toggleAddQuesiton = () => setIsAddQuestion(!getIsAddQuesiton);
  const toggleAddBlog = () => setIsAddBlog(!getIsAddBlog);


  // --- FORM VE VALIDATION ---
  const validation = useFormik({
    enableReinitialize: true, 

    initialValues: {
      productName: (getEditProject && getEditProject.Products_Name) || '',
      productDesc: (getEditProject && getEditProject.Products_Desc) || '',
      productShortDesc: (getEditProject && getEditProject.Products_ShortDescMobile) || '',
      productEngName: (getEditProject && getEditProject.Products_EngName) || '',
      productContent: (getEditProject && getEditProject.Products_ContentMobile) || '',
      productClue: (getEditProject && getEditProject.Products_ClueMobile) || '',
      productUsageTips: (getEditProject && getEditProject.Products_UsageTips) || '',
      productMainContent: (getEditProject && getEditProject.Products_Content) || '',
      productBarcode: (getEditProject && getEditProject.Products_Barcode) || '',
      
      productGR: (getEditProject && getEditProject.Products_GR) || 0,
      subCategoryId: (getEditProject && getEditProject.Products_SubCategory_ID) || '',

      // --- DÜZELTİLEN KISIM (CRITICAL FIX) ---
      // Optional Chaining (?.) ve Nullish Coalescing (??) operatörleri kullanıldı.
      // Eğer getEditProject varsa Products_IsActive değerini al, yoksa (null/undefined) true yap.
      productIsActive: getEditProject?.Products_IsActive ?? true,
      
      // Eğer getEditProject varsa Products_Owner değerini al, yoksa (null/undefined) false yap.
      productOwner: getEditProject?.Products_Owner ?? false,

      // BESİN DEĞERLERİ
      productCarbohydrate: (getEditProject && getEditProject.Products_Carbohydrate) || 0,
      productProtein: (getEditProject && getEditProject.Product_Protein) || 0,
      productEnergy: (getEditProject && getEditProject.Products_Energy) || 0,
      productOil: (getEditProject && getEditProject.Product_Oil) || 0,
      productSaturalOil: (getEditProject && getEditProject.Product_SaturalOil) || 0,
      productSalt: (getEditProject && getEditProject.Product_Salt) || 0,
      productSugar: (getEditProject && getEditProject.Product_Sugar) || 0,
    },
    validationSchema: Yup.object({
      productName: Yup.string().required("Ürün Başlığını Giriniz"),
      subCategoryId: Yup.string().required("Lütfen Alt Kategori Seçiniz"),
    }),
    onSubmit: (values) => {
      
      const baseProductData = {
        Products_Name: values.productName,
        Products_Desc: values.productDesc,
        Products_Image: getFileTr,
        Products_ShortDescMobile: values.productShortDesc,
        Products_ContentMobile: values.productContent,
        Products_ClueMobile: values.productClue,
        Products_UsageTips: values.productUsageTips,
        Products_Content: values.productMainContent,
        Products_Barcode: values.productBarcode,
        Products_EngName: values.productEngName,
        Products_ImageEng: getFileEng,
        Products_UnitText: "GR",
        
        // CHECKBOX DEĞERLERİ ARTIK values İÇİNDEN GELİYOR
        Products_IsActive: values.productIsActive,
        Products_Owner: values.productOwner,

        // SAYISAL DÖNÜŞÜMLER
        Products_GR: parseInt(values.productGR) || 0,
        Products_SubCategory_ID: parseInt(values.subCategoryId),

        Products_Carbohydrate: parseFloat(values.productCarbohydrate) || 0,
        Product_Protein: parseFloat(values.productProtein) || 0,
        Products_Energy: parseFloat(values.productEnergy) || 0,
        Product_Oil: parseFloat(values.productOil) || 0,
        Product_SaturalOil: parseFloat(values.productSaturalOil) || 0,
        Product_Salt: parseFloat(values.productSalt) || 0,
        Product_Sugar: parseFloat(values.productSugar) || 0,
      };

      if (isEdit) {
        const updateOrder = {
          ID: order ? order.ID : 0,
          ...baseProductData
        }
        dispatch(onUpdateProducts(updateOrder));
        dispatch(onGetProducts());
      } else {
        dispatch(onAddProducts(baseProductData));
      }
      validation.resetForm();
      toggle();
    },
  });

  const toggleViewModal = () => setModal1(!modal1);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
    }
  };

  const handleOrderClick = arg => {
    const order = arg;
    setEditProject(order)
    setOrder(order);
    
    setFileNameTR(order.Products_Image)
    setFileNameEng(order.Products_ImageEng)
    
    setIsEdit(true);
    toggle();
  };

  const handleDelete = async (item) => {
    try {
      axios.delete(`https://buharaapi.stechomeyazilim.info/Products_Blog(${item.ID})`).then(async (res) => {
        dispatch(onGetProducts());
      })
    } catch (err) { console.log(err) }
  };
  
  const handleAddLink = arg => {
    const order = arg;
    setLinkList(order)
    setIsAddLink(true)
    setSelectLink([])
    toggleAddLink();
  }

  const handleAddQuestion = arg => {
    const order = arg;
    setQuestion(order.Products_Question);
    setIsAddQuestion(true);
    toggleAddQuesiton();
  }

  const handleAddBlog = arg => {
    const order = arg;
    setOrderBlog(order);
    setIsAddBlog(true);
    setSelectBlog([])
    _getBlogList()
    toggleAddBlog();
  }

  const [deleteModal, setDeleteModal] = useState(false);
  const [langModal, setLangModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const onClickDelete = (order) => { setOrder(order); setDeleteModal(true); };
  const handleDeleteOrder = () => { if (order && order.ID) { dispatch(onDeleteProjects(order.ID)); setDeleteModal(false); } };
  const handleOrderClicks = () => { setOrderList(""); setIsEdit(false); toggle(); };
  
  const handleFileUpload = async (e) => { 
     // Excel Yükleme Mantığı...
  };
  const handleClick = () => { document.getElementById('fileInput').click(); };

  const columns = useMemo(() => [
      {
        Header: "Ürün Görseli",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Products_Image ? (
              <div className="avatar-xl">
                {cellProps.Products_Name != null ? <span className="avatar-title rounded-circle">{cellProps.Products_Name.charAt(0)}</span> : null}
              </div>
            ) : (
              <div><img className="avatar-xl" src={'https://buharasubdomain.stechomeyazilim.info/' + cellProps.Products_Image} alt="" /></div>
            )}
          </>
        ),
      },
      { Header: "Ürün Adı", accessor: "Products_Name", filterable: true, Cell: cellProps => <Name {...cellProps} /> },
      { Header: "Barkod", accessor: "Products_Barcode", filterable: true, Cell: cellProps => <Name {...cellProps} /> },
      { Header: 'Aktiflik', accessor: 'Products_IsActive', filterable: true, disableFilters: true, Cell: (cellProps) => <Status {...cellProps} /> },
      {
        Header: 'İşlemler', accessor: 'action', disableFilters: true, Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
               <Link to="#" className="text-success" onClick={() => {
                  const orderData = cellProps.row.original;
                  handleOrderClick(orderData);
               }}>
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              </Link>
              <Link to="#" className="text-info" onClick={() => {
                  setSelectedItem(cellProps.row.original);
                  setLangModal(true);
               }}>
                <i className="mdi mdi-translate font-size-18" id="langtooltip-product" />
                <UncontrolledTooltip placement="top" target="langtooltip-product">Çeviriler</UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-danger" onClick={() => {
                  const orderData = cellProps.row.original;
                  onClickDelete(orderData);
               }}>
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              </Link>
            </div>
          );
        }
      },
    ], []);

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status === "done" ? "Yüklendi" : "Yükleniyor"}</span>
      </div>
    )
  }

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <LangModal
        isOpen={langModal}
        toggle={() => setLangModal(false)}
        title="Ürün"
        tableName="Products_Desc"
        foreignKey="Products_ID"
        foreignKeyValue={selectedItem?.ID}
        sourceRecord={selectedItem}
        fields={[
          { name: 'Products_Image', label: 'Görsel', type: 'image' },
          { name: 'Products_Name', label: 'Ürün Adı', type: 'text' },
          { name: 'Products_Desc', label: 'Açıklama', type: 'textarea' },
          { name: 'Products_UsageTips', label: 'Kullanım İpuçları', type: 'textarea' },
          { name: 'Products_Content', label: 'Ürün İçeriği', type: 'textarea' },
          { name: 'Products_Contents', label: 'İçindekiler', type: 'textarea' },
        ]}
      />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} />
      
      {/* Upload Modal */}
      <Modal isOpen={uploadModalOpen} backdrop="static" centered>
        <ModalBody>
          <p className="text-center text-lg font-bold mb-3">Yükleme Devam Ediyor...</p>
          <Progress value={uploadProgress} color="warning" animated />
          <p className="text-center mt-2">{uploadProgress}%</p>
        </ModalBody>
      </Modal>

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Ürünler" />
          <PageHint
            what="Sitedeki bütün ürünler bu ekrandan yönetilir."
            where="Ürünler sayfasındaki kartlar ve her ürünün detay sayfası buradan beslenir. Görsel, ad, gramaj, barkod, besin değerleri ve kullanım önerisi burada girilir."
            note="Ürünün hangi grupta görüneceği “Ürün Alt Kategorileri” ile belirlenir."
            links={[{ label: 'Ürünler sayfası', path: '/urunlerimiz' }]}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                {loading && <div className="loading-screen">Yükleniyor...</div>}
                <button className="btn-rounded mb-2 me-2" onClick={handleClick}>Excel Dosyasını Yükle</button>
                <input id="fileInput" type="file" accept=".xlsx, .xls" style={{ display: 'none' }} onChange={handleFileUpload} />
                  <TableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={true}
                    isAddProducts={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Diğer modallar (Link, Soru, Blog)... */}

          {/* --- ANA ÜRÜN MODALI --- */}
          <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Ürün Düzenle" : "Ürün Ekle"}
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                <Row>
                  <Col className="col-12">
                    
                    {/* İsimler */}
                    <div className="d-flex gap-2">
                        <div className="mb-3 w-50">
                        <Label className="form-label">TR Ürün Adı</Label>
                        <Input name="productName" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productName || ""} invalid={validation.touched.productName && validation.errors.productName} />
                        {validation.touched.productName && validation.errors.productName ? (<FormFeedback type="invalid">{validation.errors.productName}</FormFeedback>) : null}
                        </div>
                        <div className="mb-3 w-50">
                        <Label className="form-label">İngilizce Başlık</Label>
                        <Input name="productEngName" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productEngName || ""} />
                        </div>
                   </div>

                   {/* Alt Kategori (Zorunlu) */}
                   <div className="mb-3">
                      <Label className="form-label">Alt Kategori</Label>
                      <Input name="subCategoryId" type="select" className="form-select" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.subCategoryId || ""} invalid={validation.touched.subCategoryId && validation.errors.subCategoryId}>
                        <option value="">Seçiniz</option>
                        {subOptions && subOptions.map((item) => (
                           <option key={item.ID} value={item.ID}>{item.SubCategory_Name || item.Name || item.Products_SubCategory_Name}</option> 
                        ))}
                      </Input>
                      {validation.touched.subCategoryId && validation.errors.subCategoryId ? (<FormFeedback type="invalid">{validation.errors.subCategoryId}</FormFeedback>) : null}
                    </div>

                    {/* Açıklamalar */}
                    <div className="mb-3">
                      <Label className="form-label">Açıklama</Label>
                      <Input name="productDesc" type="textarea" rows="3" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productDesc || ""} />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Kısa Açıklama (Mobil)</Label>
                      <Input name="productShortDesc" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productShortDesc || ""} />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Kullanım İpuçları</Label>
                      <Input name="productUsageTips" type="textarea" rows="3" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productUsageTips || ""} />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Ürün İçeriği</Label>
                      <Input name="productMainContent" type="textarea" rows="3" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productMainContent || ""} />
                    </div>

                    {/* Barkod ve Gramaj */}
                    <div className="d-flex gap-2">
                        <div className="mb-3 w-50">
                        <Label className="form-label">Barkod</Label>
                        <Input name="productBarcode" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productBarcode || ""} />
                        </div>
                        <div className="mb-3 w-50">
                        <Label className="form-label">Gramaj (GR)</Label>
                        <Input name="productGR" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productGR} />
                        </div>
                    </div>

                    {/* --- BESİN DEĞERLERİ --- */}
                    <Card className="border p-2 mb-3 bg-light">
                        <CardBody>
                            <h5 className="card-title mb-3">Besin Değerleri (100g için)</h5>
                            <Row>
                                <Col md={3} className="mb-2">
                                    <Label>Karbonhidrat</Label>
                                    <Input name="productCarbohydrate" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productCarbohydrate} />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label>Protein</Label>
                                    <Input name="productProtein" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productProtein} />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label>Enerji (kcal)</Label>
                                    <Input name="productEnergy" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productEnergy} />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label>Yağ</Label>
                                    <Input name="productOil" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productOil} />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label>Doymuş Yağ</Label>
                                    <Input name="productSaturalOil" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productSaturalOil} />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label>Tuz</Label>
                                    <Input name="productSalt" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productSalt} />
                                </Col>
                                <Col md={3} className="mb-2">
                                    <Label>Şeker</Label>
                                    <Input name="productSugar" type="number" step="0.01" onChange={validation.handleChange} value={validation.values.productSugar} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    <div className="mb-3">
                      <Label className="form-label">Ürün İçerik</Label>
                      <Input name="productContent" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productContent || ""} />
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Ürün İpucu</Label>
                      <Input name="productClue" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.productClue || ""} />
                    </div>

                    {/* Resimler */}
                    <Row>
                        <Col xs={6} className="mb-3">
                            <label>TR Görsel (800*600)</label>
                            <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusTR} maxFiles={1} styles={{ dropzone: { minHeight: 100, overflow: 'hidden' } }} PreviewComponent={Preview} accept="image/*" />
                             { getFileTr && <img className="avatar-xl mt-2" src={'https://buharasubdomain.stechomeyazilim.info/' +  getFileTr} alt="" /> }
                        </Col>
                        <Col xs={6} className="mb-3">
                            <label>ENG Görsel (800*600)</label>
                            <Dropzone getUploadParams={getUploadParams} onChangeStatus={handleChangeStatusEng} maxFiles={1} styles={{ dropzone: { minHeight: 100, overflow: 'hidden' } }} PreviewComponent={Preview} accept="image/*" />
                             { getFileEng && <img className="avatar-xl mt-2" src={'https://buharasubdomain.stechomeyazilim.info/' +  getFileEng} alt="" /> }
                        </Col>
                    </Row>

                    {/* --- DÜZELTİLEN CHECKBOX (SWITCH) ALANI --- */}
                    <div className="d-flex gap-4 mt-3">
                        {/* Aktiflik Durumu */}
                        <div className="d-flex align-items-center">
                            <label htmlFor="active-switch" className="me-2 mb-0">Aktiflik</label>
                            <div className="square-switch">
                                <input
                                    type="checkbox"
                                    id="active-switch"
                                    className="switch"
                                    name="productIsActive" // Formik ile eşleşmeli
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    checked={validation.values.productIsActive}
                                />
                                <label htmlFor="active-switch" data-on-label="Aktif" data-off-label="Pasif" />
                            </div>
                        </div>

                        {/* Buhara'ya Ait */}
                        <div className="d-flex align-items-center">
                            <label htmlFor="owner-switch" className="me-2 mb-0">Buhara'ya Ait?</label>
                            <div className="square-switch">
                                <input
                                    type="checkbox"
                                    id="owner-switch"
                                    className="switch"
                                    name="productOwner" // Formik ile eşleşmeli
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    checked={validation.values.productOwner}
                                />
                                <label htmlFor="owner-switch" data-on-label="Evet" data-off-label="Hayır" />
                            </div>
                        </div>
                    </div>
                
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <div className="text-end">
                      <button type="submit" className="btn btn-success save-user">Kaydet</button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
}

EcommerceOrder.propTypes = { preGlobalFilteredRows: PropTypes.any };

export default EcommerceOrder;